import { Controller } from "@hotwired/stimulus"

// This controller is used to toggle a css class on an element.
export default class extends Controller {
  static get values() {
    return { multiple: { type: Boolean, default: false } }
  }

  static get targets() {
    return ["button"]
  }

  connect() {
    this._closeAll()
  }

  toggle(e) {
    const open = e.target.getAttribute("aria-expanded") === "true"
    const panel = document.getElementById(e.currentTarget.getAttribute("aria-controls"))

    // Close other
    if (!this.multipleValue) {
      this._closeAll()
    }

    e.target.setAttribute("aria-expanded", `${!open}`)

    if (open) {
      panel.setAttribute("hidden", "")
    } else {
      panel.removeAttribute("hidden")
    }
  }

  _closeAll() {
    this.buttonTargets.forEach(function (button) {
      const panel = document.getElementById(button.getAttribute("aria-controls"))

      button.setAttribute("aria-expanded", "false")
      panel.setAttribute("hidden", "")
    })
  }
}
